import parse from "html-react-parser";
import { bundlesStyles } from "../..//theme/bundleStyles";

export const processText = (text: string, answers?: object, user?: object) => {
  let textValue: string = text
    .replaceAll("<", '"')
    .replaceAll(">", '"')
    .replaceAll("//n", "<br>")
    .replaceAll("\n", "<br>");

  const shortcuts = [...textValue.matchAll(/\s*([^[:]+):\"([^"]+)"/g)];
  shortcuts.forEach((match) => {
    let value = null;
    if (answers) {
      value = answers;
      if (match[1] === "id") {
        match[2].split(".").forEach((field) => {
          value = value[field]
            ? value[field]
            : Array.isArray(value)
            ? value?.find((answer) => Object.keys(answer)[0] === field)?.[field]
            : text;
        });
      }
      if (match[1] === "user") value = user?.[match[2]];
    }
    if (match[1] === "link") {
      value = `
        <a className='link'
           target='_blank'
           href='${match[2].split("$url$")[1]}'>
            ${match[2].split("$url$")[0]}
        </a>
      `;
    }
    if (match[1] === "relativelink") {
      value = `
        <a className='link'
           href='${match[2].split("$url$")[1]}'>
            ${match[2].split("$url$")[0]}
        </a>
      `;
    }
    if (match[1] === "hover") {
      value = `
      <span className='tooltip'>
      
          ${match[2].split("$text$")[0]}
          <span className="tooltiptext">
          <span className='close-thin'>X</span>
          ${match[2].split("$text$")[1]}     </span>
      </span>
    `;
    }

    if (match[1] === "quoteitalic") {
      value = "<i>" + '"' + match[2] + '"' + "</i>";
    }
    if (match[1] === "normalprice") {
      value = `<span className=${bundlesStyles().price}>
          ${match[2]}
      </span>
    `;
    }
    if (match[1] === "discountprice") {
      value = `<span className=${bundlesStyles().discount}>
          ${match[2]}
      </span>
    `;
    }
    if (match[1] === "underline") {
      value = "<u>" + match[2] + "</u>";
    }

    if (match[1] === "bold") value = "<b>" + match[2] + "</b>";
    let formattedBold = value.replaceAll("#u/", "</u>"); //this when an bold has an underline in it
    formattedBold = formattedBold.replaceAll("#u", "<u>");
    textValue = textValue.replaceAll("[" + match[0] + "]", formattedBold);
  });
  return parse(textValue);
};
